import RealGrid from "realgrid";
import { MsgBox } from "./cpmMESSAGE";
import {rgt2HiddenColumns , rgt2RowGetOpt, rgt2RowState  } from "./realgrid2.treeview.common"   ;


export const cpmRealgridTreeUtils = () => {
    /**
     * @module TreeView
     * /

    /**
     * @function
     * initGrid
     *
     * @description
     *  그리드 데이터 초기화
     *
     */
    RealGrid.TreeView.prototype.initGrid = function () {
        try {
            this.commit(true) ;
            this.getDataSource().clearRows();

            if (this.getCheckBar().visible) {
                this.checkAll(false );
            }
        } catch (e) {
        }
    };


    /**
     * @function
     * setJSON
     *
     * @description
     * JSON 데이터 원본에서 데이터를 가져와 데이터 셋을 생성
     *
     * @param data : json Data
     * @param pbAddable : 추가여부
     */
    RealGrid.TreeView.prototype.setJSON = function (data , treeId , pbAddable = false) {
        try {
            this.commit(true) ;
            if (this.getCheckBar().visible) {
                this.setAllCheck(false , false);
            }
            if(data !== null && data.length > 0 ){
                try{
                    data.sort((a, b) => {
                        a = a[treeId].toLowerCase();
                        b = b[treeId].toLowerCase();
                        if (a > b) return 1;
                        if (a < b) return -1;
                        return 0;
                    });
                    this.getDataSource().setRows(data,  treeId, true, null, null );
                    this.expandAll()   ;
                }catch (e) {
                }
                //무조건 0,0 에
                var index = {};
                index.itemIndex = 0;
                index.fieldIndex = 0;
                this.setCurrent(index);
            }else{
                this.getDataSource().clearRows();
            }
        } catch (e) {
            console.log(e)
        }
    };



    /**
     * @function
     * getId
     *
     * @description
     * realgrid가 들어가는 div의 id
     *
     * @returns {*}
     */
    RealGrid.TreeView.prototype.getId = function () {
        try {
            return this.getContainer().id;
        } catch (e) {
            console.log(e);
        }
    };

    /**
     * @function
     * setFocus
     *
     * @description
     *  그리드 특정셀에 포커스
     *
     * @param itemIndex   
     * @param field : field (필수X , String || Number)
     */
    RealGrid.TreeView.prototype.setFocus = function (itemIndex, field) {
        var index = {};
        index.itemIndex = itemIndex;
        if (field === null || field === undefined || field === "") {
            index.fieldIndex = 0;
        } else {
            if (typeof field === "string") {
                index.column = field;
            } else if (typeof field === "number") {
                index.fieldIndex = field;
            }
        }
        this.setCurrent(index);
    };

    /**
     * @function
     * setColumnVisible
     *
     * @description
     * 그리드 컬럼 visible 처리
     *
     *  @param poColName {string|Array}  컬럼명
     *  @param value : visible여부 (true, false)*
     *
     */
    RealGrid.TreeView.prototype.setColumnVisible = function (poColNames, value) {
        try {
            var _columns = [];
            var grid = this;
            var _gridId = this.getId();
            if (!(poColNames === null || poColNames === undefined || poColNames === "")) {
                if (typeof poColNames === "string") {
                    _columns.push(poColNames);
                } else {
                    _columns = poColNames;
                }
            }
            if (_columns.length === 0) {   //전체 보이게
                if (value) {   //감춘 컬럼 전체 보이기
                    rgt2HiddenColumns[_gridId].forEach(function (k, v) {
                        try {
                            grid.layoutByName(k).visible = value;
                            grid.setColumnProperty(k, 'visible',value );
                        } catch (e) {
                        }
                    });
                    rgt2HiddenColumns[_gridId] = [];
                }
            } else {
                _columns.forEach(function (k, v) {
                    try {
                        grid.layoutByName(k).visible = value;
                        grid.setColumnProperty(k, 'visible',value );
                        var _idx = rgt2HiddenColumns[_gridId].indexOf(k);
                        if (value) {
                            if (_idx >= 0) {
                                rgt2HiddenColumns[_gridId].splice(_idx, 1)
                            }
                        } else {
                            if (_idx < 0) {
                                rgt2HiddenColumns[_gridId].push(k);
                            }
                        }
                    } catch (e) {
                        console.log(e)
                    }
                })
            }
        } catch (e) {
            console.log(e);

        }
    };

    /**
     * @function
     * getColumnVisible
     *
     * @description
     * 그리드 컬럼 visible  정보
     *
     * @param poColName : 컬럼 명
     */
    RealGrid.TreeView.prototype.getColumnVisible = function (poColName) {
        try {
            var _colName = this.columnByField(poColName).name
            return this.layoutByName(_colName).visible;
        } catch (e) {
            console.log(e);

        }
    };

    /**
     * @function
     * setHeaderText
     *
     * @description
     * 그리드 컬럼 header 텍스트  처리
     *
     * @param poColName : 컬럼 명
     * @param poText   해더 텍스트
     */
    RealGrid.TreeView.prototype.setHeaderText = function (poColName, poText) {
        var _colName = "";
        if (typeof poColName === "number") {
            _colName = this.getColumn(poColName).fieldName
        } else {
            _colName = poColName;
        }

        if (this.columnByName(_colName)) {
            this.setColumnProperty(_colName, 'header', {
                text: poText
            });
        } else {
            this.layoutByName(_colName).header.text = poText;
        }
    }

    /**
     * @function
     * setFixedColumn
     *
     * @description
     * 리얼그리드  컬럼고정
     * @param colIndex {number}  컬럼index
     */
    RealGrid.TreeView.prototype.setFixedColumn = function (colIndex) {
        try {
            this.setFixedOptions({
                colCount: colIndex
            });
        } catch (e) {
            console.log(e)
        }
    };

    /**
     * @function
     * getValuesByRow
     *
     * @description
     * dataRow 으로 그리드 데이터 가져오기
     *
     * @param dataRow {string|number}
     * @returns {{}|*}
     */
    RealGrid.TreeView.prototype.getValuesByRow = function (dataRow) {
        this.commit();
        if (dataRow > -1) {
            let vaJson = this.getDataSource().getOutputRow(rgt2RowGetOpt, dataRow);
            vaJson.dataRow = dataRow;
            vaJson.itemIndex = this.getItemIndex(dataRow);
            vaJson.RowState = rgt2RowState.properties[this.getDataSource().getRowState(dataRow)].name;
            return vaJson;
        } else {
            return {};
        }
    };

    /**
     * @function
     * getValues
     *
     * @description
     * itemIndex 로 그리드 데이터
     *
     * @param itemIndex {string|number}
     * @returns {{}|*}
     */
    RealGrid.TreeView.prototype.getValues = function (itemIndex) {
        this.commit();
        let dataRow = this.getDataRow(itemIndex);
        return this.getValuesByRow(dataRow);
    };


    /**
     * @function
     * getColumnValues
     *
     * @description
     * 해당 컬럼의 전체 데이터
     *
     * @param psCol : 컬럼명
     * @returns {*}
     */
    RealGrid.TreeView.prototype.getColumnValues = function (psCol) {
        this.commit();
        return this.getDataSource().getFieldValues(psCol, 0, -1);
    }

    /**
     * @function
     * removeItemsByRow
     *
     * @description
     * dataRow 으로 그리드 삭제
     *
     * @param dataRowArray {string|number|Array}   dataRow 의 Array
     */
    RealGrid.TreeView.prototype.removeItemsByRow = function (dataRowArray) {
        try {
            this.commit();
            var rows = [];
            if (typeof dataRowArray === "string" || typeof dataRowArray === "number") {
                rows.push(dataRowArray);
            } else {
                rows = dataRowArray;
            }
            this.getDataSource().removeRows(rows, false);
        } catch (e) {
            console.log(e);

        }

    };

    /**
     * @function
     * removeItems
     *
     * @description
     * itemIndex  으로 그리드 삭제
     *
     * @param itemIndexArray  {string|number|Array}  itemIndex 의 Array
     */
    RealGrid.TreeView.prototype.removeItems = function (itemIndexArray) {
        try {
            this.commit();
            var itemIndexes = [];
            if (typeof itemIndexArray === "string" || typeof itemIndexArray === "number") {
                itemIndexes.push(itemIndexArray);
            } else {
                itemIndexes = itemIndexArray;
            }
            var _rows = this.getRowsOfItems(itemIndexes);
            this.getDataSource().removeRows(_rows, false);
        } catch (e) {
            console.log(e);

        }
    };


    /**
     * @function
     * getRowStatesValues
     *
     * @description
     * 그리드 데이터 상태에 따른 데이터 json 을 Array  반환
     *
     * @param psRowState : 그리드 상태 옵션 ('A':그리드 모든 데이터 'M':갱신,삽입,삭제 'C':삽입 'D':삭제 'U':갱신, default:'M')
     * @param psRtnMsgYn : 메시지표시 여부 ( N: 표시안함, default : Y)
     * @returns {boolean|*}
     */
    RealGrid.TreeView.prototype.getRowStatesValues = function (psRowState, psRtnMsgYn) {
        this.commit();
        var _grid = this ;
        var dataProvider = this.getDataSource();
        var _statusIndex = [];
        var jsonArray = [];

        // status에 따른 데이터
        if (psRowState === "A") {
            _statusIndex = dataProvider.getAllStateRows();
            _statusIndex["none"] = dataProvider.getStateRows();
        } else if (psRowState === "M") {
            _statusIndex = dataProvider.getAllStateRows();
        } else {
            _statusIndex[rgt2RowState[psRowState]] = dataProvider.getStateRows(rgt2RowState[psRowState]);
        }
        for (let _status in rgt2RowState.properties) {
            if (_statusIndex[_status] !== undefined) {
                _statusIndex[_status].forEach(function (dataRow, _index) {
                    var vaJson = dataProvider.getOutputRow(rgt2RowGetOpt, dataRow);
                    vaJson.dataRow = dataRow;
                    vaJson.itemIndex = _grid.getItemIndex(dataRow);
                    vaJson.RowState = rgt2RowState.properties[_status].name;
                    jsonArray.push(vaJson);
                })
            }
        }
        if (jsonArray.length <= 0) {
            if (psRtnMsgYn !== "N") {
                MsgBox.show(rgt2RowState.properties[rgt2RowState[psRowState]].msg + " 데이터가 없습니다.");
            }
            return false;
        } else {
            return jsonArray;
        }
    }


    /**
     * @function
     * getCheckedValues
     *
     * @description
     * 그리드 체크된 데이터  json 을 Array  반환
     *
     * @param psRtnMsgYn : 메시지표시 여부 ( N: 표시안함, default : Y)
     * @param commitYn : 값 가져오기전 커밋 여부 ( N: 커밋안함 , default : Y)
     * @returns {boolean|*}
     */
    RealGrid.TreeView.prototype.getCheckedValues = function (psRtnMsgYn, commitYn = "Y") {
        if(commitYn === "Y"){
            this.commit();
        }
        var _grid = this ;
        var _rows = this.getCheckedRows();

        if (_rows.length <= 0) {
            if (psRtnMsgYn !== "N") {
                MsgBox.show("선택된 데이터가 없습니다.");
            }
            return false;
        } else {
            var dataProvider = this.getDataSource();
            var jsonArray = [];
            _rows.forEach(function (dataRow, _index) {
                var vaJson = dataProvider.getOutputRow(rgt2RowGetOpt, dataRow);
                vaJson.dataRow = dataRow;
                vaJson.itemIndex = _grid.getItemIndex(dataRow);
                vaJson.RowState = rgt2RowState.properties[dataProvider.getRowState(dataRow)].name;
                jsonArray.push(vaJson);
            })
            return jsonArray;
        }
    }


    /**
     * @function
     * getMatchedColumnValues
     *
     * @description
     * stRowIndex 부처  lastRowIndex  까지의 범위에서  colIndex의 값이 dataValue와 같은 행들을 찾아서 targetCol에 해당하는 열의 값들을 배열로 반환합니다.
     *
     * @param colIndex : 찾을 컬럼
     * @param dataValue : 찾을 값
     * @param targetCol  : 데이터를 가져올 컬럼
     * @param exactMatch : 정확히 일치하는지 여부(필수X, default :true)
     * @param stRowIndex : 데이터를 가져오는 것을 시작할 행 번호(필수X, default : 0 )
     * @param lastRowIndex : 데이터를 가져오는 것을 끝낼 행 번호(필수X, default :grid.getItemCount())
     * @returns Array
     */
    RealGrid.TreeView.prototype.getMatchedColumnValues = function (colIndex, dataValue, targetCol, exactMatch, stRowIndex, lastRowIndex) {
        this.commit();
        var rtnValue = [];
        var _grid = this ;

        stRowIndex = stRowIndex || 0;
        lastRowIndex = lastRowIndex || this.getItemCount();

        //부분일치여부
        var vbPartialMatch = false;
        if (!exactMatch) {
            vbPartialMatch = true;
        }
        while (stRowIndex < lastRowIndex) {
            var options = {
                fields: [colIndex],
                values: [dataValue],
                startIndex: stRowIndex,
                caseSensitive: true,
                partialMatch: vbPartialMatch,
                wrap: false,
                select: false
            };

            var _itemIndex = _grid.searchItem(options);
            //일치된값이 없으면 주지
            if (_itemIndex === -1) {
                break;
            }
            var value = _grid.getValue(_itemIndex, targetCol);
            rtnValue.push(value);
            stRowIndex = _itemIndex + 1;
        }

        //일치된 행번호의 타겟컬럼의 값을 배열로 반환
        return rtnValue;
    }


    /**
     * @function
     * getMatchedValues
     *
     * @description
     * stRowIndex 부처  lastRowIndex  까지의 범위에서 colIndex의 값이 dataValue와 같은 행들을 찾아서 전체 데이터를 반환
     *
     *
     * @param colIndex : 찾을 컬럼
     * @param dataValue : 찾을 값
     * @param targetCol  : 데이터를 가져올 컬럼
     * @param exactMatch : 정확히 일치하는지 여부(필수X, default :true)
     * @param stRowIndex : 데이터를 가져오는 것을 시작할 행 번호(필수X, default : 0 )
     * @param lastRowIndex : 데이터를 가져오는 것을 끝낼 행 번호(필수X, default :grid.getItemCount())
     * @returns {}  일치된 행번호의 타겟컬럼의 값을 배열로 반환
     */
    RealGrid.TreeView.prototype.getMatchedValues = function (colIndex, dataValue, exactMatch, stRowIndex, lastRowIndex) {
        this.commit();
        var _grid = this ;
        var dataProvider = this.getDataSource();
        var rtnValue = [];

        stRowIndex = stRowIndex || 0;
        lastRowIndex = lastRowIndex || this.getItemCount();

        //부분일치여부
        var vbPartialMatch = false;
        if (!exactMatch) {
            vbPartialMatch = true;
        }
        while (stRowIndex < lastRowIndex) {
            var options = {
                fields: [colIndex],
                values: [dataValue],
                startIndex: stRowIndex,
                caseSensitive: true,
                partialMatch: vbPartialMatch,
                wrap: false,
                select: false
            };
            var _itemIndex = _grid.searchItem(options);
            //일치된값이 없으면 주지
            if (_itemIndex === -1) {
                break;
            }
            var _values = _grid.getValues(_itemIndex);
            _values.itemIndex = _itemIndex;
            _values.dataRow = _grid.getDataRow(_itemIndex);
            _values.RowState = rgt2RowState.properties[dataProvider.getRowState(_values.dataRow)].name;
            rtnValue.push(_values);

            stRowIndex = _itemIndex + 1;
        }

        //일치된 행번호의 타겟컬럼의 값을 배열로 반환
        return rtnValue;
    }


    /**
     * @function
     * setRowStatesItems
     *
     * @description
     * 그리드 복수의 행의 상태를 일괄 변경
     *
     * @param itemIndexArray :  itemIndex [ string || Array ]
     * @param psRowState : 그리드 상태 옵션 ('A':그리드 모든 데이터 'M':갱신,삽입,삭제 'C':삽입 'D':삭제 'U':갱신, default:'M')
     */
    RealGrid.TreeView.prototype.setRowStatesItems = function (itemIndexArray, psRowState) {
        this.commit();
        var itemIndexes = [];
        if (typeof itemIndexArray === "string" || typeof itemIndexArray === "number") {
            itemIndexes.push(itemIndexArray);
        } else {
            itemIndexes = itemIndexArray;
        }
        var _rows = this.getRowsOfItems(itemIndexes);
        this.getDataSource().setRowStates(_rows, rgt2RowState.properties[psRowState], false, false);
    }


    /**
     * @function
     * setRowStatesCheckedItems
     *
     * @description
     * 그리드 복수의 행의 상태를 일괄 변경
     *
     * @param itemIndexArray : itemIndex [ string || Array ]
     * @param psRowState : 그리드 상태 옵션 ('A':그리드 모든 데이터 'M':갱신,삽입,삭제 'C':삽입 'D':삭제 'U':갱신, default:'M')
     * @param psRtnMsgYn : 메시지표시 여부 ( N: 표시안함, default : Y)
     */
    RealGrid.TreeView.prototype.setRowStatesCheckedItems = function (psRowState, psRtnMsgYn) {
        this.commit();
        var _rows = this.getCheckedRows();
        if (_rows.length <= 0) {
            if (psRtnMsgYn !== "N") {
                MsgBox.show("선택된 데이터가 없습니다.");
            }
            return false;
        }
        this.getDataSource().setRowStates(_rows, rgt2RowState.properties[psRowState], false, false);
    }

    /**
     * 데이터를  Grid의 데이터 셋  채운다.
     * @param poJspn  : row Data
     * @param dataRow  : 데이터셋의 dataRow
     */
    RealGrid.TreeView.prototype.setValuesByRow = function (poJspn, dataRow =-1) {
        this.commit();
        try{
            if(dataRow  >= 0 ){
                this.getDataSource().setRows([poJspn], dataRow, dataRow)
            }else{
                this.getDataSource().addRow(poJspn)
            }
        }catch (e) {
            console.log(e)  ;
        }
    };
}